"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLICE_VERSIONS = void 0;
exports.sliceVersionFor = sliceVersionFor;
const slice_key_1 = require("./slice-key");
exports.SLICE_VERSIONS = {
    [slice_key_1.SliceKey.SigmaModelType]: 1,
    [slice_key_1.SliceKey.ElementSigmaModelType]: 1,
    [slice_key_1.SliceKey.Parameters]: 2,
    [slice_key_1.SliceKey.ElementParameters]: 2,
    [slice_key_1.SliceKey.SignalSet]: 1,
    [slice_key_1.SliceKey.Modes]: 1,
    [slice_key_1.SliceKey.SignalAttributes]: 1,
    [slice_key_1.SliceKey.Pinout]: 1,
    [slice_key_1.SliceKey.PinAssignments]: 1,
    [slice_key_1.SliceKey.FloatingBehaviour]: 1,
    [slice_key_1.SliceKey.SignalTies]: 2,
    [slice_key_1.SliceKey.AmrBoundaries]: 1,
    [slice_key_1.SliceKey.OcBoundaries]: 1,
    [slice_key_1.SliceKey.DriveModes]: 1,
    [slice_key_1.SliceKey.Resources]: 1,
    [slice_key_1.SliceKey.Functions]: 1,
    [slice_key_1.SliceKey.FunctionSignalMapping]: 1,
    [slice_key_1.SliceKey.Structure]: 1,
    [slice_key_1.SliceKey.SignalMapping]: 2,
    [slice_key_1.SliceKey.NcPins]: 2,
};
function sliceVersionFor(sliceKey) {
    return exports.SLICE_VERSIONS[sliceKey];
}
//# sourceMappingURL=slice-version.js.map